// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"TemplateList-module__skeletonContainer--hD7Ed","templateHeader":"TemplateList-module__templateHeader--jor1D"};